import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plans-data',
  templateUrl: './plans-data.component.html',
  styleUrls: ['./plans-data.component.scss']
})
export class PlansDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
